<button matIconButton class="timeline-icon" (click)="openDetail(rowModel)">
  <mat-icon>{{ iconString }}</mat-icon>
</button>

<mat-card appearance="raised">
  <mat-card-content>
    @let attributes =
      [
        'DisplayName',
        {attribute: 'Creator', type: 'resource'},
        {attribute: 'CreatedTime', type: 'datetime'},
        'Operation',
        'RequestStatus',
      ];
    <div class="values-row">
      @for (attr of attributes; track attr) {
        @if (typeof attr === 'string') {
          <ng-container
            *ngTemplateOutlet="item; context: {row: rowModel, attribute: attr}"
          ></ng-container>
        } @else {
          <ng-container
            *ngTemplateOutlet="
              item;
              context: {row: rowModel, attribute: attr.attribute, type: attr.type}
            "
          ></ng-container>
        }
      }
    </div>

    <ng-template #item let-row="row" let-attribute="attribute" let-type="type">
      @let attr = envConfig.getAttributeName(attribute);
      @let value = row[attr];

      @if (value) {
        <div class="value" [attr.data-attribute]="attribute" [attr.data-type]="type">
          @switch (attribute === 'DisplayName' ? 'DN' : type) {
            @case ('DN') {
              <a class="link" (click)="openDetail(rowModel)">{{ value }}</a>
            }
            @case ('resource') {
              <a class="link" (click)="openDetail(value)">{{
                displayNameForResource(value) | async
              }}</a>
            }
            @case ('datetime') {
              {{ value | localDate | async }}
            }
            @case ('timeAgo') {
              <span
                class="value__time_ago"
                [matTooltip]="
                  (getDisplayAttributeName(attr) | async) + ': ' + (value | localDate | async)
                "
                >{{ value | timeAgo | async }}</span
              >
            }
            @default {
              {{ value }}
            }
          }
        </div>
      }
    </ng-template>

    <mat-divider></mat-divider>

    @let hasError = verifyRequestDetails(rowModel, myEnv.Attributes.DetailMessage);

    <mat-expansion-panel class="main-expansion-panel mat-elevation-z0">
      <mat-expansion-panel-header>
        <div class="row-two">
          <div class="request-data">
            <language key="RequestData" defaultValue="Request Data" />:
            {{ getAttributeListAsString() | async }}
            @if (hasError) {
              <span class="error">
                <language key="Error" defaultValue="Error"></language>:
                {{ parseRequestDetails(rowModel)[myEnv.Attributes.DetailMessage] }}
              </span>
            }
          </div>
          @let createdTime = rowModel[envConfig.getAttributeName('CreatedTime')];
          @if (createdTime) {
            <div class="time-ago">{{ createdTime | timeAgo | async }}</div>
          }
        </div>
      </mat-expansion-panel-header>

      @let permPolCount = getManagementPoliciesCounter(true) | async;
      @let actionPolCount = getManagementPoliciesCounter(false) | async;
      @let wfCount = verifiedWorkflowCount$ | async;
      @let childReqCount = verifiedChildRequestCount$ | async;

      <div class="data-buttons">
        @if (permPolCount > 0) {
          <ng-template #permPolDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <mat-chip-set class="chip-preview-list">
                @for (policy of getManagementPolicies(true); track policy) {
                  @let policyObj = policy | async;
                  @if (policyObj) {
                    <mat-chip class="chip-clickable" (click)="openDetail(policyObj)">
                      {{ policyObj[myEnv.Attributes.DisplayName] }}
                    </mat-chip>
                  }
                }
              </mat-chip-set>
            </mat-dialog-content>
          </ng-template>

          <button matButton="tonal" (click)="openTemplateDlg(permPolDlgTmpl)">
            {{ permPolCount }}&nbsp;
            @if (permPolCount === 1) {
              <language key="PermissionPolicy" defaultValue="Permission Policy"></language>
            } @else {
              <language key="PermissionPolicies" defaultValue="Permission Policies"></language>
            }
          </button>
        }
        @if (actionPolCount > 0) {
          <ng-template #actionPolDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <mat-chip-set class="chip-preview-list">
                @for (policy of getManagementPolicies(false); track policy) {
                  @let policyObj = policy | async;
                  @if (policyObj) {
                    <mat-chip class="chip-clickable" (click)="openDetail(policy)">
                      {{ policyObj[myEnv.Attributes.DisplayName] }}
                    </mat-chip>
                  }
                }
              </mat-chip-set>
            </mat-dialog-content>
          </ng-template>
          <button matButton="tonal" (click)="openTemplateDlg(actionPolDlgTmpl)">
            {{ actionPolCount }}&nbsp;
            @if (actionPolCount === 1) {
              <language key="ActionPolicy" defaultValue="Action Policy"></language>
            } @else {
              <language key="ActionPolicies" defaultValue="Action Policies"></language>
            }
          </button>
        }
        @if (wfCount > 0) {
          <ng-template #workflowDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <timeline-workflow-table
                [request]="rowModel"
                (openDetail)="openDetail($event)"
              ></timeline-workflow-table>
            </mat-dialog-content>
          </ng-template>

          <button matButton="tonal" (click)="openTemplateDlg(workflowDlgTmpl)">
            {{ wfCount }}&nbsp;
            @if (wfCount === 1) {
              <language key="Workflow" defaultValue="Workflow"></language>
            } @else {
              <language key="Workflows" defaultValue="Workflows"></language>
            }
          </button>
        }
        @if (rowModel[myEnv.Attributes.ParentRequest]) {
          <ng-template #parentReqDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <mat-chip-set class="chip-preview-list">
                <mat-chip
                  class="chip-clickable"
                  (click)="openDetail(rowModel[myEnv.Attributes.ParentRequest])"
                >
                  {{ displayNameForResource(rowModel[myEnv.Attributes.ParentRequest]) | async }}
                </mat-chip>
              </mat-chip-set>
            </mat-dialog-content>
          </ng-template>

          <button matButton="tonal" (click)="openTemplateDlg(parentReqDlgTmpl)">
            <language key="ParentRequest" defaultValue="Parent Request"></language>
          </button>
        }

        @if (childReqCount > 0) {
          <ng-template #childReqDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <timeline-childrequest-table
                [request]="rowModel"
                (openDetail)="openDetail($event)"
              ></timeline-childrequest-table>
            </mat-dialog-content>
          </ng-template>

          <button matButton="tonal" (click)="openTemplateDlg(childReqDlgTmpl)">
            <language key="ChildRequests" defaultValue="Child Requests"></language>
          </button>
        }
        @if (hasError) {
          <ng-template #errorDlgTmpl>
            <mat-dialog-content class="data-dialog">
              <p>
                {{ parseRequestDetails(rowModel)[myEnv.Attributes.DetailMessage] }}
              </p>
            </mat-dialog-content>
          </ng-template>
          <button matButton="tonal" (click)="openTemplateDlg(errorDlgTmpl)" class="error-button">
            <language key="Error" defaultValue="Error"></language>
          </button>
        }
      </div>

      <request-summary-control
        [request]="modelWithRequestParameter | async"
        (openDetail)="openDetail($event)"
        [targetsToFilter]="targetList"
        [displayNameCallback]="displayNameForResource.bind(this)"
        [objectTypeCallback]="_parent.objectTypeForResource.bind(_parent)"
      ></request-summary-control>
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>
